const storeNameNumVehicles = 'VTP_NUM_VEHICLES';
const storeNameSelectedVehicle = 'VTP_SELECTED_VEHICLE';
export const getNumVehiclesOnPLP = () => {
    if (typeof window !== 'undefined') {
        const numVehicles = window.sessionStorage.getItem(storeNameNumVehicles);
        if (numVehicles && parseInt(numVehicles, 10) > 0) {
            return parseInt(numVehicles, 10);
        }
    }
    return 12;
};
export const updateNumVehiclesOnPLP = (numVehicles) => {
    if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(storeNameNumVehicles, `${numVehicles}`);
    }
};
export const resetNumVehiclesOnPLP = () => {
    if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem(storeNameNumVehicles);
        window.sessionStorage.removeItem(storeNameSelectedVehicle);
    }
};
export const setSelectedVehicle = (vehicleId) => {
    if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(storeNameSelectedVehicle, vehicleId);
    }
};
export const getSelectedVehicle = () => {
    if (typeof window !== 'undefined') {
        return window.sessionStorage.getItem(storeNameSelectedVehicle);
    }
    return undefined;
};
export const scrollToPreviouslySelectedVehicle = () => {
    const previouslySelectedVehicle = getSelectedVehicle();
    if (previouslySelectedVehicle) {
        const tile = document.getElementById(previouslySelectedVehicle);
        if (tile) {
            setTimeout(() => {
                tile.scrollIntoView();
            }, 10);
        }
        setSelectedVehicle('');
    }
};
